import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import { createCategory, getBnBCities, createQuestion, getBnbList, uploadFile } from '../../helper/backend_helper';

const AddFAQs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [answer, setAnswer] = useState('');
  const [bnb, setBnB] = useState([]);
  const [question, setQuestion] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [italianQuestion, setItalianQuestion] = useState('');
  const [italianAnswer, setItalianAnswer] = useState('');
  const [bnbcities, setBnbCities] = useState([]);
  const [cities, setCities] = useState([]);
  console.log('formData', formData.profileImage);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function fetchBnBCities() {
    try {
      const usersResponse = await getBnBCities();
      // setBnbCities(usersResponse?.data?.data);
      setBnbCities(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchBnBCities();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!question) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Question is required',
        });
        setLoading(false);
        return;
      }

      if (!answer) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Answer is required',
        });
        setLoading(false);
        return;
      }
      if (!italianQuestion) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Question is required',
        });
        setLoading(false);
        return;
      }
      if (!italianAnswer) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Answer is required',
        });
        setLoading(false);
        return;
      }
      // Prepare headers for multipart form data
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      console.log(formData.profileImage);
      let imageUploadResponse;
      if (formData.profileImage) {
        const data = new FormData();
        data.append('file', formData.profileImage);

        imageUploadResponse = await uploadFile(data, headers);
        console.log(imageUploadResponse?.data?.data?.fileName);

        if (imageUploadResponse.status !== 200) {
          throw new Error('Image upload failed');
        }
      }

      const Categorydata = {
        bnb,
        answer,
        question,
        image: imageUploadResponse?.data?.data?.fileName,
        allBnBs: isChecked,
        italianQuestion,
        italianAnswer,
        cities,
      };
      console.log(Categorydata);
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createQuestion(Categorydata, Categoryheaders);

      setFormData({
        ...formData,
        profileImage: null,
      });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'FAQ created successfully',
      });
      setQuestion('');
      setBnB([]);
      setAnswer('');
      setItalianQuestion('');
      setItalianAnswer('');
      setCities([]);

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> FAQs </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add FAQ</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="Properties this FAQ is shown for. Disabled when All BnBs is on." /></FormLabel>
              <Select
                disabled={isChecked}
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack sx={{ marginTop: 2, display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              All BnBs:
            </Typography>
            <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>
                City wise FAQ - Use this ONLY if it applies to ALL the BnB in one city <InfoTooltip title="Show this FAQ for every property in the selected cities. Use only when it applies to all BnBs in that city." />
              </FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={cities} // This will be an array
                onChange={(e) => setCities(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {bnbcities?.map((user) => (
                  <MenuItem key={user._id} value={user.name}>
                    <Checkbox checked={cities.indexOf(user.name) > -1} />
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Question <InfoTooltip title="The English question guests will see in the FAQ list for the selected properties." /></FormLabel>
            <TextField
              label="Enter Question"
              id="outlined-size-small"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
          </Stack>
          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Italian Question <InfoTooltip title="Italian translation of the question, shown to guests viewing the app in Italian." /></FormLabel>
            <TextField
              label="Enter Italian Question"
              id="outlined-size-small"
              value={italianQuestion}
              onChange={(e) => setItalianQuestion(e.target.value)}
            />
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Answer <InfoTooltip title="The English answer guests see when they open this FAQ." /></FormLabel>
            <TextField
              label="Enter Answer"
              id="outlined-multiline"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              multiline
              minRows={5}
              variant="outlined"
            />
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Italian Answer <InfoTooltip title="Italian translation of the answer, shown to guests viewing the app in Italian." /></FormLabel>
            <TextField
              label="Enter Italian Answer"
              id="outlined-multiline"
              value={italianAnswer}
              onChange={(e) => setItalianAnswer(e.target.value)}
              multiline
              minRows={5}
              variant="outlined"
            />
          </Stack>

          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack>
              {formData.profileImage && (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="img"
                  style={{ maxWidth: '300px', borderRadius: 10 }}
                />
              )}
            </Stack>
            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddFAQs;
